import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// Links the cell to the warranty's project detail. Renders the column's own
// value (j_number, name, ...) so one renderer serves every project-bound
// column; falls back to the project name when used without a field value.
const ProjectLinkRenderer = ({ value, data }) => {
  const project = data?.project;
  const label = value ?? project?.name;
  if (!project?.id) return label || null;

  return <Link to={`/crm/projects/${project.id}`}>{label}</Link>;
};

ProjectLinkRenderer.propTypes = {
  value: PropTypes.node,
  data: PropTypes.object
};

export default ProjectLinkRenderer;
